export default __webpack_public_path__ + "static/media/icon-notification-bell-v1.72067617.svg";